<div class="tab search-result-tabs">
    <div class="container-fluid" [class.tabs-ctnr-fs]="isFisherSci">
        <core-tabs-container position="columns">
            <core-tabs variant="default" icon>
                <core-tabs-item
                    label="Assays ({{ assayCount | number }})"    
                    variant="default"
                    [selected]="isSelected('assays')"
                    targetid="assay"
                    (click)="onClickTabHandler('assays')"
                    icon>
                    <ng-container *ngIf="isSelected('assays')"[ngTemplateOutlet]="assayIconSelected"></ng-container>
                    <ng-container *ngIf="!isSelected('assays')"[ngTemplateOutlet]="assayIconUnselected"></ng-container>
                </core-tabs-item>
                <core-tabs-item
                    label='Arrays ({{ arrayCount | number }})'
                    variant="default"
                    [selected]="isSelected('arrays')"
                    targetid="array"
                    (click)="onClickTabHandler('arrays')"
                    icon>
                    <ng-container [ngTemplateOutlet]="arrayIcon"></ng-container>
                </core-tabs-item>
            </core-tabs>
        </core-tabs-container>
    </div>
</div>

<ng-template #assayIconSelected>
    <svg slot="icon" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9404 2H6.94043V6H8.44043V17.5C8.44043 19.99 10.4504 22 12.9404 22C15.4304 22 17.4404 19.99 17.4404 17.5V6H18.9404V2ZM15.4404 17.5C15.4404 18.88 14.3204 20 12.9404 20C11.5604 20 10.4404 18.88 10.4404 17.5V12H15.4404V17.5ZM15.4404 10H10.4404V6H15.4404V10Z"/>
    </svg>

</ng-template>

<ng-template #assayIconUnselected>
    <svg slot="icon" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9404 2H6.94043V6H8.44043V17.5C8.44043 19.99 10.4504 22 12.9404 22C15.4304 22 17.4404 19.99 17.4404 17.5V6H18.9404V2ZM15.4404 17.5C15.4404 18.88 14.3204 20 12.9404 20C11.5604 20 10.4404 18.88 10.4404 17.5V12H15.4404V17.5ZM15.4404 10H10.4404V6H15.4404V10Z"/>
    </svg>


</ng-template>

<ng-template #arrayIcon>
    <svg slot="icon" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.9404 6V18H4.94043V6H20.9404ZM21.9404 4H3.94043C3.39043 4 2.94043 4.45 2.94043 5V19C2.94043 19.55 3.39043 20 3.94043 20H21.9404C22.4904 20 22.9404 19.55 22.9404 19V5C22.9404 4.45 22.4904 4 21.9404 4Z"/>
        <path d="M8.06042 10.76C8.96064 10.76 9.69042 10.0302 9.69042 9.13C9.69042 8.22978 8.96064 7.5 8.06042 7.5C7.1602 7.5 6.43042 8.22978 6.43042 9.13C6.43042 10.0302 7.1602 10.76 8.06042 10.76Z"/>
        <path d="M12.9404 10.76C13.8406 10.76 14.5704 10.0302 14.5704 9.13C14.5704 8.22978 13.8406 7.5 12.9404 7.5C12.0402 7.5 11.3104 8.22978 11.3104 9.13C11.3104 10.0302 12.0402 10.76 12.9404 10.76Z"/>
        <path d="M8.06042 16.51C8.96064 16.51 9.69042 15.7802 9.69042 14.88C9.69042 13.9798 8.96064 13.25 8.06042 13.25C7.1602 13.25 6.43042 13.9798 6.43042 14.88C6.43042 15.7802 7.1602 16.51 8.06042 16.51Z"/>
        <path d="M12.9404 16.51C13.8406 16.51 14.5704 15.7802 14.5704 14.88C14.5704 13.9798 13.8406 13.25 12.9404 13.25C12.0402 13.25 11.3104 13.9798 11.3104 14.88C11.3104 15.7802 12.0402 16.51 12.9404 16.51Z"/>
        <path d="M17.8104 16.51C18.7106 16.51 19.4404 15.7802 19.4404 14.88C19.4404 13.9798 18.7106 13.25 17.8104 13.25C16.9102 13.25 16.1804 13.9798 16.1804 14.88C16.1804 15.7802 16.9102 16.51 17.8104 16.51Z"/>
        <path d="M17.8104 10.76C18.7106 10.76 19.4404 10.0302 19.4404 9.13C19.4404 8.22978 18.7106 7.5 17.8104 7.5C16.9102 7.5 16.1804 8.22978 16.1804 9.13C16.1804 10.0302 16.9102 10.76 17.8104 10.76Z"/>
    </svg>
</ng-template>